import type { CSSProperties } from "react";

/** The 12 coding hues (DESIGN-RULES 5). They carry categories: tags, spaces, clients, projects, field options. */
export const HUES = ["ember", "apricot", "saffron", "citron", "fern", "jade", "lagoon", "sky", "cobalt", "iris", "orchid", "rose"] as const;
export type Hue = (typeof HUES)[number];
export type HueOrNeutral = Hue | "neutral";

/** CSS variables that point the `hue` utilities (bg-hue-subtle, text-hue-text, border-hue-border, bg-hue) at one hue. */
export function hueVars(hue: HueOrNeutral): CSSProperties {
  if (hue === "neutral") {
    return { "--hue-solid": "var(--fg-subtle)", "--hue-subtle": "var(--surface-2)", "--hue-border": "var(--border)", "--hue-text": "var(--fg-muted)" } as CSSProperties;
  }
  return {
    "--hue-solid": `var(--code-${hue}-solid)`,
    "--hue-subtle": `var(--code-${hue}-subtle)`,
    "--hue-border": `var(--code-${hue}-border)`,
    "--hue-text": `var(--code-${hue}-text)`,
  } as CSSProperties;
}

/** A stable hue from a name, so the same tag looks the same everywhere. */
export function hueFromName(name: string): Hue {
  let h = 2166136261;
  for (const ch of name.trim().toLowerCase()) h = Math.imul(h ^ ch.codePointAt(0)!, 16777619);
  return HUES[Math.abs(h) % HUES.length]!;
}
